import { useQuery } from '@tanstack/react-query';
import { api, GrRewardEarningsLeaderboardResult } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseRewardLeaderboardReturn {
  data: GrRewardEarningsLeaderboardResult | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

/**
 * "Top earners of X" leaderboard + community total. Global when `gameConfigId`
 * is undefined, per-game otherwise. Disabled until a reward type is chosen.
 */
export function useRewardLeaderboard(
  rewardType: string | null,
  gameConfigId?: string,
): UseRewardLeaderboardReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.rewardLeaderboard(rewardType!, gameConfigId),
    queryFn: () => api.getGameRewardsRewardLeaderboard(rewardType!, { gameConfigId }),
    enabled: !!rewardType,
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error:
      error instanceof Error ? error.message : isError ? 'Failed to load reward leaderboard' : null,
    refresh: () => {
      refetch();
    },
  };
}
